import React, { KeyboardEventHandler, ReactNode, useRef } from 'react';
import { IconContainer, StyledPopover, Window } from './PopoverUI';
import { PopoverActions, PopoverOrigin, PopoverProps } from '@mui/material';
import PopoverWrapper from './PopoverWrapper';
import {
  FloatingLayerProvider,
  getFloatingHostElement,
} from '../FloatingManager';

interface IProps {
  children: ReactNode;
  anchor?: PopoverProps['anchorEl'];
  isOpen: PopoverProps['open'];
  close: () => void;
  anchorOrigin?: PopoverProps['anchorOrigin'];
  customClass?: string;
  anchorPosition?: PopoverProps['anchorPosition'];
  anchorReference?: PopoverProps['anchorReference'];
}

const defaultAnchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export default ({
  children,
  close,
  isOpen,
  anchor,
  anchorOrigin,
  anchorPosition,
  anchorReference,
  customClass = 'MaterialPopoverRoot',
}: IProps) => {
  const actionRef = useRef<PopoverActions>(null);

  const handleKeydown: KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.code === 'Escape') {
      close();
    }
  };

  const handleUpdatePosition = () => {
    if (actionRef.current) {
      actionRef.current.updatePosition();
    }
  };

  return (
    <StyledPopover
      className={customClass}
      action={actionRef}
      onKeyDown={handleKeydown}
      open={isOpen}
      anchorEl={anchor}
      anchorOrigin={anchorOrigin ?? defaultAnchorOrigin}
      anchorPosition={anchorPosition}
      anchorReference={anchorReference}
      container={getFloatingHostElement()}
    >
      <Window>
        <PopoverWrapper onResize={handleUpdatePosition}>
          <FloatingLayerProvider>{children}</FloatingLayerProvider>
        </PopoverWrapper>
        <IconContainer onClick={close} />
      </Window>
    </StyledPopover>
  );
};
